import { render, staticRenderFns } from "./change-user.vue?vue&type=template&id=09f7b26d&scoped=true"
import script from "./change-user.vue?vue&type=script&lang=js"
export * from "./change-user.vue?vue&type=script&lang=js"
import style0 from "./change-user.vue?vue&type=style&index=0&id=09f7b26d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f7b26d",
  null
  
)

export default component.exports